/**
 * Router which renders views related to `Layout` models.
 * @module app/routers/admin/Layout
 */
import RouterBase from "app/routers/RouterBase";
import LayoutCollection from "app/models/LayoutCollection";
import _ from "underscore";
import $ from "jquery";
import Field from "core/models/Field";
import CollectionTableView from "core/views/CollectionTableView";
import Layout from "app/models/Layout";
import ValueCollections from "app/models/ValueCollections";
import app from "app/App";
export default RouterBase.extend({
  root: "/admin/layouts",
  initialize: function (options) {
    RouterBase.prototype.initialize.apply(this, arguments);
  },

  load: function () {
    var deferred = new $.Deferred();

    this.collection = new LayoutCollection([]);

    this.collection.fetch({
      success: _.bind(deferred.resolve, deferred),
      error: _.bind(deferred.reject, deferred),
    });

    return deferred.promise();
  },

  settings: {
    list: {
      title: "Layouts",
    },
  },

  routes: {
    "admin/layouts": "list",
  },
  /**
   * Renders a list of layer Configurations.
   */
  list: function () {
    var view = new CollectionTableView({
      fields: [
        new Field(Layout.fields["name"]),
        new Field(Layout.fields["createdAt"]),
        new Field(Layout.fields["updatedAt"]),
        new Field(
          {
            id: "owner",
            name: "owner",
            label: "owner",
            editable: false,
            valueSource: ValueCollections.User,
          },
          {
            getter: function (model) {
              if (_.isObject(model.get("owner"))) {
                return model.get("owner").id;
              } else {
                return model.get("owner");
              }
            },
          }
        ),
      ],
      collection: this.collection,
      allowSave: false,
      allowDelete: false,
      mode: "view",
      className: CollectionTableView.prototype.className + " layout-list",
    });

    view.render();

    app.pushView(view);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/routers/admin/Layout.js
// module id = 928
// module chunks = 1